import { render, staticRenderFns } from "./PcPcmClamRadio.vue?vue&type=template&id=4b0885a2&"
import script from "./PcPcmClamRadio.vue?vue&type=script&lang=js&"
export * from "./PcPcmClamRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports